import AppInput from '@nxsys/components/AppInputSearch';
import AppMenuFilter from '@nxsys/components/AppMenuFilter';
import { STATUTORY_TYPE } from '@nxsys/constants/statutory';
import { AppState } from '@nxsys/store';
import { GetStatutoryLeaveListParams, GetStatutoryPaymentListParams } from '@nxsys/store/slices/statutory/types';
import { debounce } from 'lodash';
import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import FilterModal from './FilterModal';

type ActionsHeaderProps = {
  onFilter: (params: any) => void;
  type: (typeof STATUTORY_TYPE)[keyof typeof STATUTORY_TYPE];
  fetchData: (params: GetStatutoryLeaveListParams | GetStatutoryPaymentListParams) => void;
};

export const ActionsHeader = ({
  onFilter,
  type,
  fetchData,
}: ActionsHeaderProps) => {
  const [openFilter, setOpenFilter] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  const { statutoryLeaveData, statutoryPaymentData } = useSelector(
    (state: AppState) => state.statutoryStore,
  );

  const debouncedFetchData = useCallback(
    debounce((search: string) => {
      fetchData({
        ...(type === STATUTORY_TYPE.LEAVE ? statutoryLeaveData?.queryParams : {}),
        ...(type === STATUTORY_TYPE.PAYMENT ? statutoryPaymentData?.queryParams : {}),
        page: 0,
        search,
      });
    }, 500),
    [statutoryLeaveData?.queryParams, statutoryPaymentData?.queryParams],
  );

  const toggleFilter = () => {
    setOpenFilter(!openFilter);
  }

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearchValue(value);
    debouncedFetchData(value);
  };

  return (
    <div className="flex items-center gap-2 w-full">
      <AppInput value={searchValue} onChange={handleSearchChange} />
      <AppMenuFilter options={[]} onChange={() => {}} onClick={toggleFilter} />
      <FilterModal isOpen={openFilter} toggle={toggleFilter} title='Filter' onFilter={onFilter} type={type} />
    </div>
  );
};
